import { render, staticRenderFns } from "./CustomFieldForm.vue?vue&type=template&id=5fb5ad3d"
import script from "./CustomFieldForm.vue?vue&type=script&lang=js"
export * from "./CustomFieldForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports